import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function EmailProvider() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const providerName = state?.providerName || "Provider";

  const [message, setMessage] = useState("");

  const wordCount =
    message.trim() === "" ? 0 : message.trim().split(/\s+/).length;
  const overLimit = wordCount > 1000;

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-6">
      <button
        onClick={() => navigate(-1)}
        className="text-sm text-blue-600 hover:underline"
      >
        &larr; Back
      </button>

      <h2 className="text-2xl font-bold">{providerName}</h2>

      <div>
        <label className="block mb-1 font-medium">Message</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={8}
          placeholder="Write your message here..."
          className="w-full border rounded px-3 py-2 resize-y"
        />
        <p
          className={`text-sm mt-1 ${overLimit ? "text-red-600" : "text-gray-500"}`}
        >
          {wordCount} / 1000 words
        </p>
      </div>

      <button
        disabled
        className="bg-blue-600 text-white px-5 py-2 rounded opacity-50 cursor-not-allowed"
      >
        Email Provider
      </button>
    </div>
  );
}
